import {SLOT_USER_LIMIT} from "../../../constants_calendar";

/**
 * Gets the position in the array based on the maching score
 * @param {Array} userArray the current matchpool array for the specific datetime (each element must contain property 'score')
 * @param {Number} score the score of the user to add to the array
 * @return {Number} position to which to add the user
 */
export const getPositionInMatchPoolArray = function(userArray, score) {
  let position = userArray.length;
  console.log("@getPosition: ", position, score);
  if (userArray) {
    for (let i=userArray.length; --i>=0; ) {
      if (userArray[i].score > score) break;
      position = i;
    }
  } else {
    return SLOT_USER_LIMIT;
  }
  return position;
}


const NO_PREFERENCE = 1; /* the value for no preference for any preference name */
/**
 * TODO: currently *does not* take into account private preferences of the current user, i.e. the lists etc.
 * Calculatest the matchability score by comparing current user's preferences against the other user's preferences. 
 * @param {Array} currentUserPublicPrefs current user's public preferences
 * @param {Array} otherUserPublicPrefs the other user's public preferences
 * @return {Number} the matchability score 
 * 
 * @description atm the score is calculated in base-3, since the preference values can either match, the first user might not care, or they might be opposite 
 * The priority for the current user determines the position (i.e. the power) and the multiplier is determined by whether the preferences match or not. 
 */
export function getMatchabilityScore(currentUserPublicPrefs, otherUserPublicPrefs) {
  let score = 0;
  const length = currentUserPublicPrefs.length;
  for (let i=0; i<length; i++) {
    if (currentUserPublicPrefs[i].preference === NO_PREFERENCE) continue; 
    const power = 2-currentUserPublicPrefs[i].priority;
    let multiplier = 2;
    for (let j=0; j<length; j++) {
      if (otherUserPublicPrefs[j].name == currentUserPublicPrefs[i].name) {
        multiplier = 2-Math.abs(otherUserPublicPrefs[j].preference-currentUserPublicPrefs[i].preference);
        break;
      }
    }
    score += multiplier*3**power;
  }
  return score;
}
